
            const data = {"name":"spinner","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.258 13.742a6 6 0 0 1-2.5-9.985.5.5 0 0 1 .706.707A5 5 0 1 0 8 3a.5.5 0 0 1 0-1 6 6 0 1 1-1.742 11.742Z\" _fill=\"#85A7FF\"/>","originalColors":[{"type":"fill","color":"#85A7FF"}],"stopColors":[]}}
        
                    module.exports = data
                    